export default "__VITE_ASSET__DcewfMgq__"